import linkifyIt from 'linkify-it';
const linkify = linkifyIt();
export default function isURL(text) {
    return !!linkify.match(text);
}
// from https://github.com/markdown-it/linkify-it/blob/master/support/demo_template/index.js
// behavior: http://markdown-it.github.io/linkify-it/
// docs: http://markdown-it.github.io/linkify-it/doc/#Match.prototype.text
// ========================
function escape(str) {
    return str.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
}
export function linkifyText(content) {
    let out = escape(content);
    const matches = linkify.match(content);
    const result = [];
    let last;
    if (matches) {
        last = 0;
        matches.forEach((match) => {
            if (last < match.index) {
                result.push(escape(content.slice(last, match.index)).replace(/\r?\n/g, '<br>'));
            }
            result.push('<a target="_blank" rel="noopener noreferrer" href="');
            result.push(escape(match.url));
            result.push('">');
            result.push(escape(match.text));
            result.push('</a>');
            last = match.lastIndex;
        });
        if (last < content.length) {
            result.push(escape(content.slice(last)).replace(/\r?\n/g, '<br>'));
        }
        out = result.join('');
    }
    return out;
}
export function linkifyTextWithPretest(content) {
    if (linkify.pretest(content)) {
        return linkifyText(content);
    }
    return content;
}
// ========================
